/**
 * useGalleryAssets – get all gallery MediaAssets for an entity.
 */
import { useMediaAssets } from './useMediaAssets';
import { resolveAssetUrl } from '@/lib/media/mediaApi';
import type { MediaAsset, OwnerType, VariantWidth } from '@/lib/media/mediaTypes';

export interface GalleryAssetsResult {
  assets: MediaAsset[];
  getUrl: (asset: MediaAsset, variant?: VariantWidth) => string | null;
  urls640: string[];
  urls320: string[];
  isLoading: boolean;
}

export function useGalleryAssets(
  ownerType: OwnerType,
  ownerId: string | null | undefined,
): GalleryAssetsResult {
  const { data, isLoading } = useMediaAssets(ownerType, ownerId, 'gallery', null);
  const assets = data ?? [];

  const getUrl = (asset: MediaAsset, variant: VariantWidth = 640) =>
    resolveAssetUrl(asset, variant);

  return {
    assets,
    getUrl,
    urls640: assets.map(a => resolveAssetUrl(a, 640)).filter(Boolean) as string[],
    urls320: assets.map(a => resolveAssetUrl(a, 320)).filter(Boolean) as string[],
    isLoading,
  };
}
